import React, { useEffect, useState } from 'react';
import { ControlLabel, FormGroup, HelpBlock, MenuItem } from 'react-bootstrap';
import classNames from 'classnames';
import Combobox from '../../../../Combobox.jsx';
import { CloseIcon } from '../../../../icons/CloseIcon.jsx';
import { getOrgTermsContent } from '../../../../../content/utils.js';

const OrgStakeholdersSelect = (props) => {
  const {
    orgStakeholders,
    selectedOrgStakeholderId,
    setSelectedOrgStakeholderId,
    customClass,
    onShowAddStakeholderModal,
    meta,
    addBtn,
  } = props;

  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(meta.touched && meta?.error);
  }, [meta]);

  useEffect(() => {
    setHasError(meta.submitError);
  }, [meta.submitError]);

  const handleRemove = () =>
    window.confirm('Are you sure you want to detach this stakeholder?') &&
    setSelectedOrgStakeholderId(null);

  const onInputValueChange = (inputValue) =>
    orgStakeholders.filter(({ fullName }) =>
      fullName.toLowerCase().includes(inputValue.toLowerCase())
    );

  const onSelectedItemChange = (stakeholder) => {
    setHasError(false);
    return setSelectedOrgStakeholderId(stakeholder.id);
  };

  const isActive = (stakeholder) => selectedOrgStakeholderId === stakeholder.id;

  const fullName = () => {
    const stakeholder = orgStakeholders.find(
      ({ id }) => id === selectedOrgStakeholderId
    );
    return stakeholder
      ? `${stakeholder.fullName} ${stakeholder.archived ? '(archived)' : ''}`
      : '';
  };

  const CustomMenuItem = (props) => {
    const { item, getItemProps, index } = props;
    const { archived } = item;

    const active = isActive(item);

    return (
      <MenuItem
        className={classNames({ active })}
        key={item.id}
        {...getItemProps({
          index,
        })}
      >
        <span className={archived && !active ? 'text-muted' : ''}>
          {archived ? `${item.fullName} (archived)` : item.fullName}
        </span>
      </MenuItem>
    );
  };

  return (
    <FormGroup validationState={hasError ? 'error' : null}>
      <ControlLabel className="flex flex-justify">
        Select Stakeholder
        {addBtn}
      </ControlLabel>
      <div className={`m-b-12 ${customClass}`}>
        <div className="bulk-select m-b-12">
          <div className="flex flex-align-start flex-wrap">
            {selectedOrgStakeholderId ? (
              <div className="flex m-t-4 m-l-4 item-style">
                {fullName()}
                <span
                  onClick={handleRemove}
                  className="btn btn-clear close-btn"
                >
                  <CloseIcon />
                </span>
              </div>
            ) : null}
          </div>
          <Combobox
            entities={orgStakeholders}
            onInputValueChange={onInputValueChange}
            onSelectedItemChange={onSelectedItemChange}
            isActive={isActive}
            getItemName={(item) => item.fullName}
            placeholder="Start Typing"
            controlId="org-stakeholder"
            customMenuItem={CustomMenuItem}
          />
        </div>
        {hasError && (
          <HelpBlock>
            {getOrgTermsContent(meta.error || meta.submitError)}
          </HelpBlock>
        )}
      </div>
    </FormGroup>
  );
};

export default OrgStakeholdersSelect;
